import Vue from 'vue'
import EventBus from '@/includes/EventBus'

Vue.use(EventBus)
